class MurabahaRoutes {
  static readonly MURABAHA = '/murabaha';
  static readonly MURABAHA_BUY = `${MurabahaRoutes.MURABAHA}/buy`;
  static readonly MURABAHA_BUY_ORDER_DETAILS = `${MurabahaRoutes.MURABAHA_BUY}/:id`;
  static readonly MURABAHA_TASKS = `${MurabahaRoutes.MURABAHA}/tasks`;
  static readonly MURABAHA_TASKS_DETAILS = `${MurabahaRoutes.MURABAHA_TASKS}/:id`;

  static readonly MURABAHA_TRANSFER_UNITS = `${MurabahaRoutes.MURABAHA}/transfer-units`;
  static readonly TRANSFER_UNITS = `${MurabahaRoutes.MURABAHA_TRANSFER_UNITS}/transfer`;
  static readonly TRANSFER_UNITS_HISTORY = `${MurabahaRoutes.MURABAHA_TRANSFER_UNITS}/history`;
  static readonly TRANSFER_UNITS_DETAILS = `${MurabahaRoutes.MURABAHA_TRANSFER_UNITS}/history/:id`;
  static readonly TRANSFER_MARKET_SELL = `${MurabahaRoutes.MURABAHA_TRANSFER_UNITS}/market-sell/:id`;
  static readonly TRANSFER_MARKET_SELL_ID = `${MurabahaRoutes.MURABAHA_TRANSFER_UNITS}/market-sell`;
  static readonly TRANSFER_UNITS_HOME = `${MurabahaRoutes.MURABAHA_TRANSFER_UNITS}`;
  static readonly TRANSFER_SELL_WITHDRAWAL = `${MurabahaRoutes.MURABAHA_TRANSFER_UNITS}/sell-withdrawal/:id`;

  //
  static readonly MURABAHA_USERS = '/investors-murabaha';
  static readonly MURABAHA_USER_DETAILS = '/investors-murabaha/:id';
  static readonly CREATE_MURABAHA_USER = '/investors-murabaha/create-user';
  static readonly MURABAHA_INVESTORS = '/investors-murabaha/investors';

  static readonly BANK_INTEGRATION = '/bank-integration';
  static readonly BANK_INTEGRATION_API_APP_CLIENTS = `${MurabahaRoutes.BANK_INTEGRATION}/create-app`;
  static readonly BANK_INTEGRATION_API_APP_CLIENTS_SUCCESS = `${MurabahaRoutes.BANK_INTEGRATION_API_APP_CLIENTS}/success`;
}

export default MurabahaRoutes;
